<template>
  <div class="product-container pt-5 position-relative vw-100">
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterModal"
        v-on:enter="actions.enterModal"
        v-on:leave="actions.leaveModal"
    >
		<div class="product-instructions">
			<LocalizedLink to="/"  class="close-detail position-absolute"></LocalizedLink>

			<arrow arrow-class="arrow-left" target="/bed"></arrow>
			<arrow arrow-class="arrow-right" target="/awning-hangout"></arrow>

			<div class="product-copy-container">
				<transition name="bounce">
					<div v-if="show">
				<div class="product-title">
					<div class="product-name" v-html="$t('shower_screen.title')"></div>
				</div>
				<div class="product-inst" v-html="$t('shower_screen.content')"></div>
					</div>
				</transition>
			</div>

		</div>
    </transition>
    <transition
        appear
        v-bind:css="false"
        v-on:before-enter="actions.beforeEnterProduct"
        v-on:enter="actions.enterProduct"
        v-on:leave="actions.leaveProduct"
    >

		<div class="product-detail position-absolute">
      <div class="detail-inner">
        <img :src="require('@/assets/imgs/product-four/product.png')" />
      </div>
		</div>
    </transition>

  </div>
</template>

<script>
import Arrow from "../Arrow";
import LocalizedLink from '@/components/LocalizedLink'
import {inject} from "vue";

export default {
  name: "ShowerFashionClosetPage",
  components: {
		Arrow,
		LocalizedLink
	},
	setup() {
    const store = inject("store");
    return {
      actions: store.actions
    };
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 800);
  }
}
</script>

<style scoped lang="scss">
  .product-container {
    overflow: visible;
  }

	@media screen and (max-width: 728px) {
    // .product-container {
    //   height: 100vh;
    //   padding: 0 !important;
    // }
    // .product-instructions {
    //   position: absolute;
    //   bottom: 15%;      
    // }
    .product-detail {
      height: auto;
      bottom: 0;
    }

		.detail-inner {
			position: absolute;
			float: right; /* this was added and display removed */
      right: 0;
      top: auto;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: center;      
			img {
        height: 90vh;
        width: auto;
			}
		}
	}
	@media screen and (min-width: 729px) {
    .product-detail {
      top: 0;
      bottom: auto;
      img {
        max-height: 90vh;
      }
    }
    // .product-instructions {
    //   margin-top: 45vh;
    // }

    .detail-view {
      &.shower {
        // .product-detail {
        //   top: -10vh;
        //   bottom: 0;
        //   img {
        //     height: 100vh;
        //     max-height: 100vh;
        //   }
        // }
      }
    }
  }
</style>
